import React, { createContext, useContext } from 'react'
import { client, builder } from 'src/config/sanityClient'

const getImageUrl = (asset: any) => {
  if (!asset) return ''
  return builder.image(asset).url()
}

const SanityContext = createContext({ client, builder, getImageUrl })

const SanityProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <SanityContext.Provider value={{ client, builder, getImageUrl }}>
      {children}
    </SanityContext.Provider>
  )
}

export const useSanity = () => useContext(SanityContext)
export default SanityProvider
